const Trips = {
  tripPath: (id: string) => `/api/trips/${id}`,
  tripsPath: () => '/api/trips',
  ticketsPath: () => '/api/tickets',
  stationsPath: () => '/api/stations',
  verifyTripPricePath: () => '/ExternalSale/VerifyTripPrices'
};

export default Trips;
